import axios from 'axios';
import { Folder } from './folders.types';

export async function fetchFolders(): Promise<Folder[]> {
  return (await axios.get('/folders/listFolders')).data;
}

export function removeDecisionFromFolder(
  docId: string,
  folderKey: string,
): Promise<{}> {
  return axios.post('/folders/removeDecision', {
    docId,
    folderKey,
  });
}

export function renameFolder({
  folderKey,
  title,
}: {
  folderKey: string;
  title: string;
}): void {
  axios.post('/folders/renameFolder', { folderKey, title });
}

export function deleteFolder(folderKey: string): void {
  axios.post('/folders/deleteFolder', { folderKey });
}

export async function createFolder(title: string): Promise<string> {
  const {
    data: { folderKey },
  } = await axios.post('/folders/createFolder', {
    title,
  });
  return folderKey;
}

export async function fetchFoldersChronologically(): Promise<Folder[]> {
  return (
    await axios.get('/folders/listFolders', {
      params: {
        sort: 'chrono',
      },
    })
  ).data;
}

export function addDecisionToFolder({
  docId,
  folderKey,
}: {
  docId: string;
  folderKey: string;
}): Promise<{}> {
  return axios.post('/folders/addDecision', {
    docId,
    folderKey,
  });
}

export async function createAndAddDecisionToFolder({
  docId,
  title,
}: {
  docId: string;
  title: string;
}): Promise<{ folderKey: string }> {
  return (
    await axios.post('/folders/createAndAddDecision', {
      docId,
      title,
    })
  ).data;
}

export function addMultipleDecisionToFolder({
  docIds,
  folderKey,
}: {
  docIds: string[];
  folderKey: string;
}): void {
  axios.post('/folders/addDecisions', {
    docIds,
    folderKey,
  });
}
